import { ref } from 'vue'

const DESKTOP_RESOLUTION = 768

export function useIsMobile() {
  const isMobile = ref<boolean>()
  const error = ref<unknown>(null)

  try {
    const query = window.matchMedia(`(max-width: ${DESKTOP_RESOLUTION}px)`)
    isMobile.value = query.matches

    query.onchange = (e) => {
      isMobile.value = e.matches
    }
  } catch (err) {
    error.value = err
  }

  return {
    isMobile,
    error
  }
}
